import { List, useTable } from "@refinedev/antd";
import { Table, Tag, Select, Space, Typography } from "antd";
import { Link } from "react-router";
import type { PaymentListItem } from "../../types";
import { fmtRub, fmtDateTime, fmtUserName } from "../../utils";

const STATUS_COLOR: Record<string, string> = {
  paid: "green", pending: "blue", expired: "default", refunded: "orange",
};

export const PaymentList = () => {
  const { tableProps, filters, setFilters } =
    useTable<PaymentListItem>({
      syncWithLocation: true,
      sorters: { initial: [{ field: "id", order: "desc" }] },
    });

  const sf = filters.find(f => "field" in f && f.field === "status");
  const gf = filters.find(f => "field" in f && f.field === "gateway");

  return (
    <List title="Платежи" breadcrumb={false}>
      <Space style={{ marginBottom: 12 }} wrap>
        <Select style={{ width: 160 }} placeholder="Все статусы" allowClear
          value={(sf && "value" in sf ? sf.value : undefined) as string | undefined}
          onChange={(v) => setFilters([
            { field: "status", operator: "eq", value: v ?? "" },
            ...filters.filter(f => "field" in f && f.field !== "status"),
          ], "replace")}
          options={[
            { value: "paid", label: "✅ Оплачены" },
            { value: "pending", label: "⏳ Ждут" },
            { value: "expired", label: "⌛ Истекли" },
            { value: "refunded", label: "↩ Возвраты" },
          ]} />
        <Select style={{ width: 180 }} placeholder="Все шлюзы" allowClear
          value={(gf && "value" in gf ? gf.value : undefined) as string | undefined}
          onChange={(v) => setFilters([
            { field: "gateway", operator: "eq", value: v ?? "" },
            ...filters.filter(f => "field" in f && f.field !== "gateway"),
          ], "replace")}
          options={[
            { value: "cryptobot", label: "CryptoBot" },
            { value: "cryptocloud", label: "CryptoCloud" },
          ]} />
      </Space>
      <Table {...tableProps} rowKey="id" scroll={{ x: 900 }}>
        <Table.Column dataIndex="id" title="ID" sorter width={70} />
        <Table.Column<PaymentListItem>
          title="Юзер"
          render={(_, r) => <Link to={`/users/${r.user_id}`}>{fmtUserName(r)}</Link>}
        />
        <Table.Column dataIndex="gateway" title="Шлюз"
          render={(v: string) => <Tag>{v}</Tag>} />
        <Table.Column<PaymentListItem>
          dataIndex="final_rub" title="Сумма" align="right" sorter
          render={(_, r) => (
            <Space direction="vertical" size={0} align="end">
              <Typography.Text strong>{fmtRub(r.final_rub)}</Typography.Text>
              {r.amount_usdt &&
                <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                  {r.amount_usdt} USDT
                </Typography.Text>}
            </Space>
          )}
        />
        <Table.Column dataIndex="status" title="Статус"
          render={(s: string) => <Tag color={STATUS_COLOR[s]}>{s}</Tag>} />
        <Table.Column<PaymentListItem>
          title="Корзина"
          render={(_, r) => (
            <Space direction="vertical" size={0}>
              {r.cart.map((item, i) => (
                <Typography.Text key={i} style={{ fontSize: 12 }}>
                  {item.tariff} × {item.months}мес
                  {item.children > 1 && ` (${item.children} детей)`}
                </Typography.Text>
              ))}
            </Space>
          )}
        />
        <Table.Column dataIndex="created_at" title="Создан" sorter render={fmtDateTime} />
        <Table.Column dataIndex="paid_at" title="Оплачен" render={fmtDateTime} />
      </Table>
    </List>
  );
};
